define((require) => {
    "use strict";

    var DashboardConfigurationFactory           = require("ui/dashboard/DashboardConfigurationFactory"),
        ProjectDashboardContentCollectionView   = require("ui/projects/content/ProjectDashboardContentCollectionView"),
        ProjectDashboardImageLibraryView        = require("ui/projects/image/ProjectDashboardImageLibraryView"),
        ProjectDashboardPublishView             = require("ui/projects/publish/ProjectDashboardPublishView");

    /**
     * Describes the tab configuration needed by the project dashboard - providing project specific views and a different path.
     *
     * @class ProjectDashboardConfiguration
     */
    return DashboardConfigurationFactory.create({
        EXPERIENCES: {
            view: ProjectDashboardContentCollectionView,
            path: function(context) {
                return "project/" + context.project.get("id");
            }
        },
        IMAGES: {
            view: ProjectDashboardImageLibraryView,
            path: function(context) {
                return "project/" + context.project.get("id") + "/images";
            }
        },
        PUBLISH: {
            view: ProjectDashboardPublishView,
            path: function(context) {
                return "project/" + context.project.get("id") + "/publish";
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/dashboard/ProjectDashboardConfiguration.js